
export const experienceData = [
    {
        id: 1,
        company: 'We are currently seeking talented individuals to join our team as we build an open project. If you have the skills and passion to contribute, we would love to hear from you.' ,
        jobtitle: 'Expanding: We are hiring! ',
        startYear: 'Q1',
        endYear: '2023'
    },
    {
        id: 2,
        company: '',
        jobtitle: ' In terms of utility, we are currently in talks with Gokai Labs to find a solution to use EBUD tokens in their weed shop in Thailand, where cannabis trade is legal. We are also working on a second collection of NFTs, which will have a limited supply and will be used to create a liquidity pool. ' ,
        startYear: 'Q1',
        endYear: '2023'
    },
    {
        id: 1,
        company: 'Within this new world, you want to be able to create value, you want to be able to transfer value, you want to be able to easily own something and exchange it, or share it with friends. ' ,
        jobtitle: 'This brings us very close to the first stepping stone.   ',
        startYear: 'Q2',
        endYear: '2023'
    },

]